<template>
  <el-dialog title="修改密码" @open="dialogOpen" width="400px" :visible.sync="dialogControl.dialogVisible" append-to-body>
    <el-container>
        <el-main >
                <el-form  style="margin-top:10px;" :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item label="原密码" prop="oldPassword">
                        <el-input type="password" placeholder="请输入原密码" v-model="ruleForm.oldPassword" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="新密码" prop="password">
                        <el-input type="password" placeholder="请输入新密码" v-model="ruleForm.password" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="重复新密码" prop="repeatPassword">
                        <el-input type="password" placeholder="再次输入新密码" v-model="ruleForm.repeatPassword" auto-complete="off"></el-input>
                    </el-form-item>
                </el-form>
        </el-main>
    </el-container>
    <div slot="footer" class="dialog-footer">
        <el-button @click="dialogControl.dialogVisible = false;">取 消</el-button>
        <el-button type="primary"  @click="savePassword">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { changePassword } from '@/api/user/user'
import { mapGetters } from 'vuex'
export default {
  name: 'ChangePassword',
  components: { },
  props: {
    dialogControl: {
      type: Object,
      default: function() {
        return { dialogVisible: false }
      }
    }
  },
  data() {
    var validatePassword = (rule, value, callback) => {
      if (value !== '') {
        this.$refs.ruleForm.validateField('repeatPassword')
      }
      callback()
    }
    var validateRepeatPassword = (rule, value, callback) => {
      if (value !== this.ruleForm.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      ruleForm: {
        oldPassword: '',
        password: '',
        repeatPassword: ''
      },
      rules: {
        password: [
          { validator: validatePassword, trigger: 'blur' },
          { min: 6, message: '密码最少为6位', trigger: 'blur' },
          { required: true, message: '新密码不能为空', trigger: 'blur' }
        ],
        repeatPassword: [
          { validator: validateRepeatPassword, trigger: 'blur' },
          { min: 6, message: '密码最少为6位', trigger: 'blur' },
          { required: true, message: '重复新密码不能为空', trigger: 'blur' }
        ],
        oldPassword: [
          { min: 6, message: '密码最少为6位', trigger: 'blur' },
          { required: true, message: '旧密码不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters([
      'userId'])
  },
  methods: {
    dialogOpen() {
      if (this.$refs['ruleForm']) {
        this.$refs['ruleForm'].resetFields()
      }
    },
    // 保存电子签名
    savePassword() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          changePassword({ id: this.userId, oldPassword: this.ruleForm.oldPassword, newPassword: this.ruleForm.password }).then(response => {
            this.dialogControl.dialogVisible = false
            this.$notify({ title: '成功', message: '修改密码成功。', type: 'success', position: 'bottom-right' })
            this.$refs['ruleForm'].resetFields()
          }).catch(response => {})
        }
      })
    }
  },
  watch: {
  }
}
</script>


// WEBPACK FOOTER //
// src/views/layout/components/Account/ChangePassword.vue